var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-skeleton-loader',{attrs:{"type":"table-thead, table-tbody, table-tfoot","loading":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }